import { render, staticRenderFns } from "./NoteCreateModal.vue?vue&type=template&id=325d2c36"
import script from "./NoteCreateModal.vue?vue&type=script&lang=js"
export * from "./NoteCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports